import React, { Component } from 'react';

class InclusionExclusion extends Component {
    render() {
        return (
            <>
                <h4 className='tomato1'>INCLUSIONS: <strong>NORTH SIKKIM PACKAGE TOUR FROM KOLKATA</strong></h4><br/><br/>
                <ul>
                <li><span className="green-dot"><i className="fa fa-check" aria-hidden="true"></i></span>   
                    &nbsp;&nbsp;Accommodation at Hotels and Resorts
                    </li><br/>
                    <li><span className="green-dot"><i className="fa fa-check" aria-hidden="true"></i></span>   
                    &nbsp;&nbsp;Breakfast, Evening Snack, Dinner
                    </li><br/>
                    <li><span className="green-dot"><i className="fa fa-check" aria-hidden="true"></i></span>&nbsp;&nbsp;Private vehicle</li><br/>
                    <li><span className="green-dot"><i className="fa fa-check" aria-hidden="true"></i></span>&nbsp;&nbsp;Toll Tax, Permits, and Parking fees</li><br/>
                    <li><span className="green-dot"><i className="fa fa-check" aria-hidden="true"></i></span>&nbsp;&nbsp;Driver and fuel allowance</li><br/>
                    <li><span className="green-dot"><i className="fa fa-check" aria-hidden="true"></i></span>&nbsp;&nbsp;Pickup and Drop</li><br/>
                </ul>
                <br/><br/><br/>
                <h4 className='tomato1'>EXCLUSIONS: <strong>NORTH SIKKIM TOUR PACKAGE FROM KOLKATA</strong></h4><br/><br/>
                <ul>
                    <li><span className="red-dot"><i className="fa fa-times" aria-hidden="true"></i></span>   
                    &nbsp;&nbsp;Sightseeing point entry fees</li><br/>
                    <li><span className="red-dot"><i className="fa fa-times" aria-hidden="true"></i></span>   
                    &nbsp;&nbsp;Any other meals that the ones mentioned above</li><br/>
                    <li><span className="red-dot"><i className="fa fa-times" aria-hidden="true"></i></span>   
                    &nbsp;&nbsp;BBQs or House Parties</li><br/>
                    <li><span className="red-dot"><i className="fa fa-times" aria-hidden="true"></i></span>   
                    &nbsp;&nbsp;Any extra service consumed by the guest</li><br/>
                    
                </ul>
            </>
        );
    }
}

export default InclusionExclusion;